import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import styles from "./dropdown.module.scss";

const getOptionValue = (option) =>
  option && typeof option === "object" ? option.value : option;

const getOptionLabel = (option) =>
  option && typeof option === "object" ? option.label : option;

const SingleSelect = ({ label, value, onChange, options, name }) => {
  return (
    <FormControl fullWidth className={styles.dropdownControl}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={onChange} name={name}>
        {options.map((option) => {
          const optionValue = getOptionValue(option);
          return (
            <MenuItem key={optionValue} value={optionValue}>
              {getOptionLabel(option)}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SingleSelect;
